// extracted by mini-css-extract-plugin
export default {"header__info":"styles_header__info__2MuNd"};